var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCheckIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.69272 13.992L0.281574 8.00084C0.0795925 7.77838 0.0946016 7.43446 0.312964 7.2284L1.81148 5.8732C2.03803 5.66985 2.38739 5.68896 2.59076 5.91551L6.13379 9.82154L13.4256 2.00144C13.5253 1.89362 13.6631 1.83084 13.8105 1.82538C13.9579 1.81992 14.1012 1.87315 14.2076 1.97414L15.6857 3.35117C15.7935 3.4508 15.8563 3.59001 15.8604 3.73741C15.8658 3.88344 15.8112 4.02674 15.7103 4.13319L6.51046 14.0003C6.40537 14.1136 6.25662 14.1763 6.10102 14.175C5.94544 14.1736 5.79782 14.108 5.69272 13.992Z",
    fill: "#29A9E0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckIcon);
export default __webpack_public_path__ + "static/media/check-icon.ab91c99b0ca67fe3fc5fae6917b929e6.svg";
export { ForwardRef as ReactComponent };